/*
 * Product page: gallery, ingredient hotspots (H12), 360° spin (H11), variant picker,
 * pack selector (1 / 2 / 3 packs), subscribe-and-save, quantity, mobile sticky add-to-cart.
 */
(function () {
  const money = (c, trim) => (window.Sansu && Sansu.formatMoney) ? Sansu.formatMoney(c, trim) : (c / 100).toFixed(0);

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const formId = 'ProductForm-' + root.dataset.section;
    const form = document.getElementById(formId);

    /* ---------- Gallery ---------- */
    const track = root.querySelector('[data-gallery-track]');
    const thumbs = [...root.querySelectorAll('[data-thumb]')];
    const goTo = id => {
      const slide = document.getElementById(id);
      if (!slide || !track) return;
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };
    thumbs.forEach(t => t.addEventListener('click', () => goTo(t.dataset.thumb)));
    if (track && thumbs.length) {
      const io = new IntersectionObserver(es => es.forEach(e => {
        if (e.intersectionRatio > .6) thumbs.forEach(t => t.toggleAttribute('aria-current', t.dataset.thumb === e.target.id));
      }), { root: track, threshold: .6 });
      [...track.children].forEach(s => io.observe(s));
    }

    /* ---------- Hotspots ---------- */
    const hoverable = matchMedia('(hover: hover)').matches;
    const closeAll = except => root.querySelectorAll('[data-hotspot][aria-expanded="true"]').forEach(d => {
      if (d === except) return;
      d.setAttribute('aria-expanded', 'false'); document.getElementById(d.getAttribute('aria-controls')).hidden = true;
    });
    root.querySelectorAll('[data-hotspot]').forEach(dot => {
      const card = document.getElementById(dot.getAttribute('aria-controls'));
      const set = open => { dot.setAttribute('aria-expanded', open); card.hidden = !open; };
      dot.addEventListener('click', e => {
        e.stopPropagation();
        // With a mouse the hover has already opened the card, so a click keeps it open instead of toggling it shut
        const open = hoverable || dot.getAttribute('aria-expanded') !== 'true';
        closeAll(dot);
        set(open);
      });
      if (hoverable) {
        dot.addEventListener('mouseenter', () => set(true));
        dot.parentElement.addEventListener('mouseleave', () => set(false));
      }
      dot.addEventListener('keydown', e => { if (e.key === 'Escape') set(false); });
    });
    document.addEventListener('click', () => closeAll());

    /* ---------- 360° spin: frames load only when the spin slide is reached ---------- */
    const spin = root.querySelector('[data-spin]');
    if (spin) {
      const img = spin.querySelector('.spin__img');
      let frames = [], loaded = false, idx = 0;
      const load = () => {
        if (loaded) return; loaded = true;
        frames = JSON.parse(spin.dataset.frames);
        frames.forEach(src => { const i = new Image(); i.src = src; }); // warm the cache
      };
      new IntersectionObserver(es => { if (es[0].isIntersecting) load(); }, { threshold: .3 }).observe(spin);
      const show = n => { if (!frames.length) return; idx = (n % frames.length + frames.length) % frames.length; img.src = frames[idx]; };
      let startX = null, startIdx = 0;
      spin.addEventListener('pointerdown', e => { load(); startX = e.clientX; startIdx = idx; spin.setPointerCapture(e.pointerId); spin.classList.add('is-dragging'); });
      spin.addEventListener('pointermove', e => {
        if (startX === null) return;
        const step = spin.clientWidth / Math.max(frames.length, 1) / 1.5;
        show(startIdx + Math.round((e.clientX - startX) / step));
      });
      const end = () => { startX = null; spin.classList.remove('is-dragging'); };
      spin.addEventListener('pointerup', end); spin.addEventListener('pointercancel', end);
      spin.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight') { load(); show(idx + 1); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { load(); show(idx - 1); e.preventDefault(); }
      });
    }

    /* ---------- Quantity (the pack selector writes into it) ---------- */
    let qty = root.querySelector('[data-qty-input]');
    if (!qty && form) {
      qty = Object.assign(document.createElement('input'), { type: 'hidden', name: 'quantity', value: 1 });
      qty.setAttribute('form', formId);
      form.appendChild(qty);
    }
    root.querySelectorAll('[data-qty-step]').forEach(b => b.addEventListener('click', () => {
      qty.value = Math.max(1, Math.min(20, (+qty.value || 1) + +b.dataset.qtyStep));
      syncCourse();
    }));
    if (qty) qty.addEventListener('change', syncCourse);

    const course = root.querySelector('[data-course]');
    let currentPrice = null;
    function renderCourse(price) {
      if (!course) return;
      course.querySelectorAll('input').forEach(input => {
        const packs = +input.value;
        input.closest('label').querySelector('[data-course-total]').textContent = money(price * packs);
      });
    }
    function syncCourse() {
      if (!course || !qty) return;
      course.querySelectorAll('input').forEach(i => { i.checked = +i.value === +qty.value; });
    }
    if (course) {
      course.addEventListener('change', e => { if (qty) qty.value = e.target.value; });
      const checked = course.querySelector('input:checked');
      if (checked && qty) qty.value = checked.value;
    }

    /* ---------- Subscribe and save ---------- */
    const sub = root.querySelector('[data-subscription]');
    const planInput = root.querySelector('[data-selling-plan]');
    if (sub && planInput) {
      const update = () => { const r = sub.querySelector('input[type="radio"]:checked'); planInput.value = r ? r.value : ''; };
      sub.addEventListener('change', e => {
        if (e.target.matches('[data-selling-plan-select]')) {
          const radio = e.target.closest('.subscribe__freq').previousElementSibling.querySelector('input');
          radio.value = e.target.value; radio.checked = true;
        }
        update();
      });
      update();
    }

    /* ---------- Variant picker ---------- */
    const picker = root.querySelector('[data-variant-picker]');
    if (picker) {
      const variants = JSON.parse(picker.querySelector('[data-variants]').textContent);
      picker.addEventListener('change', () => {
        const chosen = [...picker.querySelectorAll('fieldset')].map(f => f.querySelector('input:checked').value);
        const v = variants.find(x => x.options.every((o, n) => o === chosen[n]));
        const btn = root.querySelector('[data-add-button]');
        const sticky = root.querySelector('[data-sticky-add]');
        if (!v) {
          btn.disabled = true; btn.textContent = Sansu.strings.unavailable;
          return;
        }
        root.querySelector('[data-variant-id]').value = v.id;
        btn.disabled = sticky.disabled = !v.available;
        btn.textContent = v.available ? Sansu.strings.addToCart : Sansu.strings.soldOut;
        const now = root.querySelector('[data-price-wrap] .price__now');
        const compare = root.querySelector('[data-price-wrap] .price__compare');
        if (now) now.textContent = money(v.price);
        if (compare) compare.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
        const sp = root.querySelector('[data-sticky-price]');
        if (sp) sp.textContent = money(v.price);
        renderCourse(v.price);
        if (v.featured_media) goTo(root.querySelector(`[data-media-id="${v.featured_media.id}"]`)?.id);
        const url = new URL(location.href); url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      });
    }

    /* ---------- Mobile sticky add-to-cart ---------- */
    const sticky = root.querySelector('[data-sticky-atc]');
    const mainBtn = root.querySelector('[data-add-button]');
    if (sticky && mainBtn && matchMedia('(max-width: 899px)').matches) {
      // On phones the main button sits below the gallery, so the bar shows whenever it is off screen
      // (above or below) and Add to cart is always within thumb reach.
      new IntersectionObserver(([e]) => { sticky.hidden = e.isIntersecting; }).observe(mainBtn);
    }
  }

  document.querySelectorAll('[data-product]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-product]').forEach(init));
})();
